module.exports = __webpack_public_path__ + "img/example-daily-menu-arrows.ea426761.webp";